import { createFileRoute } from '@tanstack/react-router'

import { LearnpathsAddElementsScormAdd } from '@/learnpaths/components/LearnpathsAddElementsScormAdd/LearnpathsAddElementsScormAdd'

export const Route = createFileRoute(
  '/company/learnpaths/add/elements/$learnpathId/(scorm)/create/scorm',
)({
  component: RouteComponent,
  validateSearch: (search: { index?: number }) => search,
})

function RouteComponent() {
  const params = Route.useParams()
  return <LearnpathsAddElementsScormAdd mode="create" {...params} />
}
